"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasH264 = exports.hasVP8 = exports.getGlobalDocument = exports.hasOpus = exports.hasH264Capability = exports.hasVP8Capability = exports.hasOpusCapability = void 0;
exports.checkCapabilitiesForRoom = checkCapabilitiesForRoom;
const adapter_1 = require("../../../api/adapter");
const feature_1 = require("../../../api/adapter/features/feature");
const browser_support_1 = require("../browser-support");
const mediasoup_device_1 = require("../mediasoup-device");
async function checkCapabilitiesForRoom(capabilities) {
    try {
        const dev = (0, mediasoup_device_1.createMediasoupDevice)();
        await dev.load({ routerRtpCapabilities: capabilities });
        return {
            audio: dev.canProduce("audio"),
            video: dev.canProduce("video"),
        };
    }
    catch (err) {
        throw new Error(`current browser/device not supported: ${err}`);
    }
}
const hasOpusCapability = async (log) => {
    let capabilities;
    try {
        capabilities = await checkCapabilitiesForRoom({
            codecs: [browser_support_1.OPUS_CAPABILITY],
        });
    }
    catch (err) {
        const msg = err instanceof Error ? err.message : "unknown error";
        log === null || log === void 0 ? void 0 : log.warn("support: no opus capabilities support", {
            ...adapter_1.device.browserInfo,
            err: msg,
        });
        return false;
    }
    if (!capabilities.audio) {
        log === null || log === void 0 ? void 0 : log.warn("support: no opus capabilities support", {
            ...adapter_1.device.browserInfo,
        });
        return false;
    }
    log === null || log === void 0 ? void 0 : log.debug("support: have opus capabilities support", {
        ...adapter_1.device.browserInfo,
    });
    return true;
};
exports.hasOpusCapability = hasOpusCapability;
const hasVP8Capability = async (log) => {
    let capabilities;
    try {
        capabilities = await checkCapabilitiesForRoom({
            codecs: [browser_support_1.VP8_CAPABILITY],
        });
    }
    catch (err) {
        const msg = err instanceof Error ? err.message : "unknown error";
        log === null || log === void 0 ? void 0 : log.warn("support: no vp8 capabilities support", {
            ...adapter_1.device.browserInfo,
            err: msg,
        });
        return false;
    }
    if (!capabilities.video) {
        log === null || log === void 0 ? void 0 : log.warn("support: no vp8 capabilities support", {
            ...adapter_1.device.browserInfo,
        });
        return false;
    }
    log === null || log === void 0 ? void 0 : log.debug("support: have vp8 capabilities support", {
        ...adapter_1.device.browserInfo,
    });
    return true;
};
exports.hasVP8Capability = hasVP8Capability;
const hasH264Capability = async (log) => {
    let capabilities;
    try {
        capabilities = await checkCapabilitiesForRoom({
            codecs: [browser_support_1.H264_CAPABILITY],
        });
    }
    catch (err) {
        const msg = err instanceof Error ? err.message : "unknown error";
        log === null || log === void 0 ? void 0 : log.warn("support: no h264 capabilities support", {
            ...adapter_1.device.browserInfo,
            err: msg,
        });
        return false;
    }
    if (!capabilities.video) {
        log === null || log === void 0 ? void 0 : log.warn("support: no h264 capabilities support", {
            ...adapter_1.device.browserInfo,
        });
        return false;
    }
    log === null || log === void 0 ? void 0 : log.debug("support: have h264 capabilities support", {
        ...adapter_1.device.browserInfo,
    });
    return true;
};
exports.hasH264Capability = hasH264Capability;
const hasOpus = () => true;
exports.hasOpus = hasOpus;
// to mock globalThis.document in tests
const getGlobalDocument = () => {
    return globalThis.document;
};
exports.getGlobalDocument = getGlobalDocument;
const hasVP8 = () => {
    try {
        if ((0, exports.getGlobalDocument)() == null) {
            // if we don't have document, we're polyfilling code support anyway
            return true;
        }
    }
    catch (ex) {
        return true;
    }
    return !adapter_1.device.isIosDevice && !adapter_1.device.isSafari && !adapter_1.device.isEdge;
};
exports.hasVP8 = hasVP8;
const hasH264 = (log) => {
    try {
        if ((0, exports.getGlobalDocument)() == null) {
            // if we don't have document, we're polyfilling code support anyway
            return true;
        }
    }
    catch (ex) {
        return true;
    }
    if (adapter_1.device.isChrome) {
        if (adapter_1.device.isImplements(feature_1.Feature.MEDIA_RECORDER)) {
            if (adapter_1.device.MediaRecorder.isTypeSupported("video/webm; codecs=h264")) {
                log === null || log === void 0 ? void 0 : log.debug("support: h264 support: chrome");
                return true;
            }
            log === null || log === void 0 ? void 0 : log.warn("support: no h264 support", {
                reason: "chrome without h264",
                ...adapter_1.device.browserInfo,
            });
        }
        else {
            log === null || log === void 0 ? void 0 : log.flush();
            return false;
        }
    }
    if (adapter_1.device.isAndroidDevice) {
        log === null || log === void 0 ? void 0 : log.warn("support: no h264 support", {
            reason: "android device",
            ...adapter_1.device.browserInfo,
        });
        return false;
    }
    return adapter_1.device.isImplements(feature_1.Feature.MEDIA_DEVICE) && adapter_1.device.isCodecSupported("h264");
};
exports.hasH264 = hasH264;
//# sourceMappingURL=codecs.js.map